import styled from 'styled-components';
import { Text15Regular } from '../Text/Text.styles';

export const Container = styled.div`
  display: flex;
  gap: 0.8rem;
  cursor: pointer;

  svg {
    flex-shrink: 0;
  }
`;

export const Label = styled(Text15Regular)`
  margin-top: 0.3rem;
  line-height: 2rem;
  user-select: none;

  a {
    color: white;
  }
`;
